export default __webpack_public_path__ + "static/media/img7.fa5846bf.jpg";